var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
	
$(document).ready(function() {
	var forms = document.querySelectorAll('#frmSupport');

    Array.prototype.slice.call(forms)
      .forEach(function (form) {
        form.addEventListener('submit', function (event) {
		  if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          event.preventDefault();
          event.stopPropagation();
          form.classList.add('was-validated');
          sendSupport(form.checkValidity());
        }, false)
      });

	$(".phone").mask("999999999999999");
	
	$("#gsm_code").intlTelInput({
      	preferredCountries: [CommonPayment.countryCode],
		americaMode: false
    });
    
	$("#gsm_code").focusout(function(){
		var isTR = $("[name=gsm_code]").val().includes("+90");
		if(isTR){
			$("[name=gsm]").mask("(999) 999-9999");
		}else{
			$("[name=gsm]").mask("999999999999999");
		}
	});

	$(".email").validate();
});

var recaptchaSupport;
function onloadCallbackContact(){
	recaptchaSupport = grecaptcha.render('recaptchaSupport', {
        'sitekey' : captchasitekey
      });
}

function sendSupport(isvalid){
	if(!isvalid) return false;
	if(grecaptcha.getResponse(recaptchaSupport).length == 0){
		alert(FmtMessage.getMessage('js.check.googlecaptcha.warn'));
		return false;
	}else {
		$.ajax({
	    	type:'POST',
	        async:false,
	        url: '/a/supportWithForm',
	        data: $("#frmSupport").serialize(),
	        success: function(data) {
	        	$("#response").show();
				$(window).scrollTop(0);
	        	if(data){
	        	    resetSupportForm();
	        		$('#btnSupport').attr("disabled", true);
	        		$("#failure").hide();
	        		$("#success").show();
					$('html, body').animate({scrollTop:$('.inner-page-title').offset().top}, 'slow');
					$("#frmSupport").validate().cancelSubmit = true;
	        	}else{
	        		$("#success").hide();	
	        		$("#failure").show();
	        	}
	         },
	        error: function() {
	            //alert('Error occured');
	        }
	    });
		grecaptcha.reset(recaptchaSupport);
	}
}
		
function reloadCaptcha() {
	$('#captcha').attr('src', '/a/captcha?' + new Date().getTime());
}

function resetSupportForm() {
	$("[name=supportType]").val("");
	$("[name=referenceNo]").val("");
	$("[name=name]").val("");
	$("[name=surname]").val("");
	$("[name=email]").val("");
	$("[name=gsm]").val("");
	$("[name=subject]").val("");
	$("[name=content]").val("");
}